import clsx from 'clsx'

import { Flex, Text } from '@buffer-mono/popcorn'

import sharedStyles from '../chart-shared.module.css'

import styles from './MetricsNarrativeChart.module.css'

import type { JSX } from 'react'

interface BenchmarkSummaryPanelProps {
  channelRate: number | null
  medianRate: number | null
  percentileRank: number | null
}

function formatRate(value: number): string {
  return `${value.toFixed(2)}%`
}

export function BenchmarkSummaryPanel({
  channelRate,
  medianRate,
  percentileRank,
}: BenchmarkSummaryPanelProps): JSX.Element {
  const topPercent =
    percentileRank != null && percentileRank > 50
      ? Math.round(100 - percentileRank)
      : null

  return (
    <Flex align="start" gap="lg" className={styles.summaryRow}>
      {/* Growth rate block */}
      <Flex direction="column" gap="2xs">
        <Text className={styles.summaryMetricName}>Growth Rate</Text>
        <Flex align="center" gap="xs">
          <span
            className={clsx(
              sharedStyles.colorDot,
              sharedStyles.colorDotBenchmarkChannel,
            )}
            aria-hidden="true"
          />
          <Flex align="baseline" gap="xs">
            <p className={styles.summaryValue}>
              {formatRate(channelRate ?? 0)}
            </p>
            {medianRate != null && (
              <Text className={styles.summarySubtext}>
                {formatRate(medianRate)} median
              </Text>
            )}
          </Flex>
        </Flex>
      </Flex>

      {/* Percentile rank block — only shown when above median */}
      {topPercent != null && (
        <>
          <div className={styles.summaryDivider} aria-hidden="true" />
          <Flex direction="column" gap="2xs">
            <Text className={styles.summaryMetricName}>
              Buffer users with similar accounts
            </Text>
            <p className={styles.summaryValue}>Top {topPercent}%</p>
          </Flex>
        </>
      )}
    </Flex>
  )
}
